import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { config } from '../config';

export function useSignOut(): () => Promise<void> {
  const { instance } = useMsal();
  return useCallback(async () => {
    const account = instance.getActiveAccount() ?? undefined;
    await instance.logoutRedirect({ account, postLogoutRedirectUri: `${config.origin}/` });
  }, [instance]);
}
